/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_RunInputs */

const cs_property_lustrace_run = /** @type {(inputs: Property_Lustrace_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit lustraci nemovitosti`)
};

const en_property_lustrace_run = /** @type {(inputs: Property_Lustrace_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run property lustrace`)
};

/**
* | output |
* | --- |
* | "Run property lustrace" |
*
* @param {Property_Lustrace_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_run = /** @type {((inputs?: Property_Lustrace_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_run(inputs)
	return cs_property_lustrace_run(inputs)
});